import React, { useMemo } from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";

import { Status } from "@components/tailwindComponents";

import { TaskStatus } from "@helpers/moduleConstants/taskConstants";

const StatusStyles = {
  assigned: {
    text: "Attribuée",
    background: "arh-bg-greenColor"
  },
  waiting: {
    text: "En attente",
    background: "arh-bg-[#FAD860]"
  },
  terminated: {
    text: "Terminée",
    background: "arh-bg-[#D9D9D9]"
  },
  overdue: {
    text: "En retard",
    background: "arh-bg-[#FF6B6B]"
  },
  notApplicable: {
    text: "Non-applicable",
    background: "arh-bg-[#E5E2E2]"
  }
};

const WITH_FOLDER_TASK_TYPE = [
  "document_sending",
  "upload_request",
  "signature_request",
  "electronic_signature"
];

export default function EmployeTaskStatusCell(props) {
  const { task } = props;

  const { t: translate } = useTranslation("beginEnd.protocol");

  const formattedStatus = useMemo(() => {
    if (task.status === TaskStatus.COMPLETED) {
      return "terminated";
    }

    if (task.status === TaskStatus.NOT_APPLICABLE) {
      return "notApplicable";
    }

    if (
      task.predictedDate &&
      task.predictedDate < moment().format("YYYY-MM-DD")
    ) {
      return "overdue";
    }

    if (
      task.assignedTo?.length &&
      (task.predictedDate || task.predictedDateTriggerTask) &&
      (!WITH_FOLDER_TASK_TYPE.includes(task.expectedResultType) || task.targetFolder)
    ) {
      return "assigned";
    }

    return "waiting";
  }, [task]);

  const statusStyle = useMemo(() => {
    return StatusStyles[formattedStatus];
  }, [formattedStatus]);

  return (
    <div className="arh-flex arh-items-center arh-justify-between">
      <span
        className={`arh-font-poppins arh-text-xs arh-font-medium  ${task.status === "notApplicable" ? "arh-text-[#505256] arh-underline " : "arh-text-darkGreyColor "} `}
      >
        {translate(statusStyle.text)}
      </span>
      <Status className={statusStyle.background} />
    </div>
  );
}
